export default {"src":"/_next/static/media/boxGroup2.40789768.svg","height":118,"width":103};